 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		20: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~lazy-imports~marcInit","1":"vendors~listOfIssuesAccordion~profile","2":"DownloadMarcForm","3":"article","4":"audioPlayer","7":"clientPagination","8":"connectProfileMenu","9":"dashboardToolbar","10":"datepicker","11":"disableADBlocker","12":"embedPopup","13":"favorites","14":"instructorsIdentificationForms","15":"instructorsService","16":"landingPage","17":"lazy-imports","18":"listOfIssuesAccordion","19":"loi","21":"marcInit","22":"mathjax","23":"plugins/maphilight","25":"profile","26":"requestidlecallback-polyfill","27":"search","28":"showRecommended","29":"testSummary","30":"testWidget","31":"toggleTable","32":"truncate","33":"vendors~article","34":"vendors~dynamic-imports","35":"vendors~fileUploader","36":"vendors~ie-imports","37":"vendors~lazy-imports","38":"vendors~pd","39":"vendors~plugins/sortable","40":"vendors~profile","41":"vendors~search","42":"vendors~slideshow","43":"widgets/test-widget-hotspot","44":"widgets/test-widget-sortable","45":"widgets/test-widget-timer"}[chunkId]||chunkId) + "-" + {"0":"98df9dbab1eeb07ad28c","1":"1aeb04b8235b9a83337f","2":"127b81d80465ecde85c7","3":"955eacb38761989d167a","4":"b3d87fca4fed57f80465","7":"3bd4f263025bc3e2298f","8":"6206f9b84fb8857e6237","9":"f443ebe9adde61d5497a","10":"1828f02e710863b2bb2f","11":"ef7daa3182ca6780a819","12":"dd3b2eae75023f70fdd5","13":"1f052fdae37c59499b40","14":"d82866fafd27a2e931b5","15":"c661f992f1e2b09420df","16":"547c0f8d117f176536ec","17":"f0b57d47b5ff0befb260","18":"bacc055b07f254fcf489","19":"bf970736bd1965944ea7","21":"584723ff572937a4c731","22":"ce88f1bf63bbce066c5a","23":"c476cbd140adb1544561","25":"d53b880b145aef136bda","26":"5eac6fb8178380b87ea4","27":"f7996e6b97578ae4240d","28":"289f2d0f40d5c02e520a","29":"a6b3b27131a9ddb9dde0","30":"a4a6de05edf84f55bad2","31":"3472af1ced1fa015a9eb","32":"d1dd4968fff7fdcc4ed9","33":"79d7d80568f5c26fa674","34":"895f13029d0ab4133ec6","35":"b0b1561fe093691fdf0e","36":"07f7cc034f73b945eb71","37":"ec59298777a9bbb99827","38":"e0db7166acd2687ec676","39":"f114c66dfe924fc22c0f","40":"31352df3dd7ba267c7a0","41":"32291bb837497dd8b593","42":"dd591207fd870ca76e60","43":"ebcb19e29868e50d8c39","44":"2ea2f9218f0c2aec6337","45":"20e3c53c1ef8210e841d","46":"62c8d34b04e774aa5493"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 20);
